import { SelectOptions } from '@/ui/types';
import { t } from '@/ui/i18n/i18n';
import { ReminderDirections, ReminderTypes, ReminderScales } from '@/entities/schedule/constants';

export const scales: SelectOptions<string> = [
  {
    value: ReminderScales.Minute,
    label: t('schedules.reminder-notification.minute'),
  },
  {
    value: ReminderScales.Hour,
    label: t('schedules.reminder-notification.hour'),
  },
  {
    value: ReminderScales.Day,
    label: t('schedules.reminder-notification.day'),
  },
  {
    value: ReminderScales.Week,
    label: t('schedules.reminder-notification.week'),
  },
  {
    value: ReminderScales.Month,
    label: t('schedules.reminder-notification.month'),
  },
];

export const directions: SelectOptions<string> = [
  {
    value: ReminderDirections.Before,
    label: t('schedules.reminder-notification.before'),
  },
  {
    value: ReminderDirections.After,
    label: t('schedules.reminder-notification.after'),
  },
];

export const types: SelectOptions<string> = [
  {
    value: ReminderTypes.Available,
    label: t('schedules.reminder-notification.availability'),
  },
  {
    value: ReminderTypes.Due,
    label: t('schedules.reminder-notification.due-date'),
  },
];
